'use client';
import { useSuspenseQuery, useQuery } from '@tanstack/react-query';
import { ORDER_QUERIES } from '../../infrastructure/order/utils/queries';
import type { GetOrderRequest, GetUserOrdersRequest } from '../../infrastructure/order/utils/types';

export const useOrderService = () => {
  const useGetOrder = (params: GetOrderRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getOrder(params));
  };

  const useGetUserOrders = (params: GetUserOrdersRequest) => {
    return useQuery(ORDER_QUERIES.getUserOrders(params));
  };

  return {
    useGetOrder,
    useGetUserOrders,
  };
};

